import React from "react";
import StrokeIcon from "./StrokeIcon";

/** Maintenance: a wrench. Was the RFQ icon (shared with RFQ's) until 2026-10-01. */
export default function MaintenanceIcon(props?: any) {
  return (
    <StrokeIcon iconProps={props}>
      {() => (
        <path d="M11.6 2.2a3.6 3.6 0 0 0-4.5 4.6L2.2 11.7a1.5 1.5 0 0 0 0 2.1l2 2a1.5 1.5 0 0 0 2.1 0l4.9-4.9a3.6 3.6 0 0 0 4.6-4.5l-2.3 2.3-2.4-.6-.6-2.4 2.3-2.3z" />
      )}
    </StrokeIcon>
  );
}
